import React, { useState, useEffect } from "react";
import "./Promotions.scss";
import { getDecryptedToken } from "../../utils/crypto/cryptoUtils";
import baseUrl from "../../api/baseUrl";

interface PromotionsProps {
  onPromotionsLoaded?: (hasPromotions: boolean) => void;
  isInline?: boolean;
}

const Promotions: React.FC<PromotionsProps> = ({
  onPromotionsLoaded,
  isInline = false,
}) => {
  const [promotions, setPromotions] = useState<any[]>([]);
  const [currentPromotionIndex, setCurrentPromotionIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const martId = getDecryptedToken("selectedMartId");
    if (martId) {
      baseUrl
        .get(`/public/mart/${martId}`)
        .then((response) => {
          if (
            response.data &&
            response.data.data &&
            response.data.data.MartAdvertisements
          ) {
            // Sort by priority (ascending) and map with duration
            const ads = response.data.data.MartAdvertisements.sort(
              (a: any, b: any) => a.priority - b.priority,
            ).map((ad: any) => ({
              ...ad,
              duration: ad.type === "video" ? 30000 : 5000,
            }));
            setPromotions(ads);
            if (onPromotionsLoaded) {
              onPromotionsLoaded(ads.length > 0);
            }
          } else {
            if (onPromotionsLoaded) {
              onPromotionsLoaded(false);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching mart promotions:", error);
          if (onPromotionsLoaded) {
            onPromotionsLoaded(false);
          }
        });
    } else {
      if (onPromotionsLoaded) {
        onPromotionsLoaded(false);
      }
    }
  }, [onPromotionsLoaded]);

  useEffect(() => {
    if (promotions.length > 1) {
      const { duration } = promotions[currentPromotionIndex];
      const timer = setTimeout(() => {
        setIsTransitioning(true);
        setTimeout(() => {
          setCurrentPromotionIndex(
            (prevIndex) => (prevIndex + 1) % promotions.length,
          );
          setIsTransitioning(false);
        }, 300);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [currentPromotionIndex, promotions]);

  if (promotions.length === 0) {
    if (isInline) {
      return (
        <div className="promotions-container inline-mode">
          <div className="promo-inner">
            <div className="promo-icon">🎉</div>
            <div className="promo-title">SPECIAL OFFERS</div>
            <div className="promo-subtitle">Amazing deals for you!</div>
          </div>
        </div>
      );
    }
    return (
      <div className="promotions-container">
        <div className="promo-inner">
          <div className="promo-icon">🎉</div>
          <div className="promo-title">SPECIAL OFFERS</div>
          <div className="promo-subtitle">Amazing deals for you!</div>
          <div className="promo-extra">Check out our latest promotions</div>
        </div>
      </div>
    );
  }

  const currentPromotion = promotions[currentPromotionIndex];

  return (
    <div className={`promotions-container ${isInline ? "inline-mode" : ""}`}>
      <div
        className={`media-wrapper ${isTransitioning ? "fade-out" : "fade-in"}`}
      >
        {currentPromotion.type === "image" && (
          <img
            src={`${baseUrl.defaults.baseURL}${currentPromotion.url}`}
            alt="Promotion"
            className="promotion-media"
          />
        )}
        {currentPromotion.type === "video" && (
          <video
            src={`${baseUrl.defaults.baseURL}${currentPromotion.url}`}
            autoPlay
            muted
            loop
            className="promotion-media"
          ></video>
        )}
      </div>

      {promotions.length > 1 && (
        <div className="promotion-indicators">
          {promotions.map((_, index) => (
            <div
              key={index}
              className={`indicator ${index === currentPromotionIndex ? "active" : ""}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Promotions;
